/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {z} from '@hono/zod-openapi';

import {advertisementPayloadSchema} from './AdvertisementPayloadSchema';
import {
  advertisingAdapterErrorCodeSchema,
  advertisingCredentialsSchema,
  advertisingImageSchema,
  advertisingOperationSchema,
  advertisingPlatformCodeSchema,
  advertisingPublicationStatusSchema,
} from './AdvertisingCommonSchemas';

export const advertisingJobMessageSchema = z.object({
  jobId: z.string().uuid(),
  tenantId: z.string().uuid(),
  vehicleId: z.string().uuid(),
  platformCode: advertisingPlatformCodeSchema,
  operation: advertisingOperationSchema,
  publishingBranchId: z.string().uuid().nullable(),
  externalId: z.string().nullable(),
  vehicle: advertisementPayloadSchema,
  images: z.array(advertisingImageSchema),
  credentials: advertisingCredentialsSchema.nullable(),
});

export const vehicleMappingErrorDetailsSchema = z.object({
  mappingReason: z.string(),
  reasonCode: z.string().nullable(),
  blockingDimension: z.string().nullable(),
  candidateExternalIds: z.array(z.string()),
  selectedExternalIds: z.array(z.string()),
  configurationBundleId: z.string().uuid().nullable(),
  mappingRuleSetId: z.string().uuid().nullable(),
  taxonomyBatchId: z.string().uuid().nullable(),
});

export const advertisementJobCompletedEventSchema = z.object({
  jobId: z.string().uuid(),
  tenantId: z.string().uuid(),
  status: z.enum(['done', 'failed']),
  publicationStatus: advertisingPublicationStatusSchema.optional(),
  publicationId: z.string().uuid().nullable(),
  externalId: z.string().nullable(),
  linkToAd: z.string().nullable(),
  errorCode: advertisingAdapterErrorCodeSchema.nullable(),
  errorMessage: z.string().nullable(),
  errorDetails: vehicleMappingErrorDetailsSchema.nullable().optional(),
});

export const advertisingFeedRunMessageSchema = z.object({
  feedRunId: z.string().uuid(),
  tenantId: z.string().uuid(),
  platformCode: advertisingPlatformCodeSchema,
  feedKey: z.string().min(1),
});

export type AdvertisingJobMessage = z.infer<typeof advertisingJobMessageSchema>;
export type AdvertisingFeedRunMessage = z.infer<typeof advertisingFeedRunMessageSchema>;
export type AdvertisementJobCompletedEvent = z.infer<typeof advertisementJobCompletedEventSchema>;
export type VehicleMappingErrorDetails = z.infer<typeof vehicleMappingErrorDetailsSchema>;
